import { render, staticRenderFns } from "./WarehouseProductMap.vue?vue&type=template&id=370097b8&scoped=true&"
import script from "./WarehouseProductMap.vue?vue&type=script&lang=js&"
export * from "./WarehouseProductMap.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseProductMap.vue?vue&type=style&index=0&id=370097b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370097b8",
  null
  
)

export default component.exports